import React,{useState,useEffect,useRef} from 'react'
import Functions from './function'
import { useParams } from 'react-router-dom';
import { QRCodeSVG } from "qrcode.react";
import Logo from '../../../images/public/websitefooter.png'
import ToothChart from '../../../components/labeltoothchart'
import CaseDetails from '../../../components/labelcasedetails'
import './index.css'

// 4in x 3in sticker (Zebra TLP 2844-Z). Expressed in mm because 101.6 x 76.2 is exact,
// where cm/in round.
const LABEL_PAGE_CSS = '@page { size: 101.6mm 76.2mm; margin: 0; }';

const Index = () => {
    const [orderdata,setOrderData] = useState(null);
    const {id} = useParams();
    // useRef, not a plain let: a local would reset on every render and never guard anything,
    // so window.print() could fire more than once.
    const inprint = useRef(false);

    // The page size has to be injected at runtime rather than declared in index.css. CRA
    // concatenates every stylesheet into one bundle that loads on every route, and @page is
    // document-global with no way to scope it to a selector - so a @page rule in the CSS file
    // would also resize the billing statement and all four job cards. Injecting it here binds
    // it to this page's lifetime, and the cleanup removes it again.
    useEffect(()=>{
        const style = document.createElement('style');
        style.setAttribute('data-label-page','');
        style.textContent = LABEL_PAGE_CSS;
        document.head.appendChild(style);
        return ()=>{ style.remove(); };
    },[])

    useEffect(()=>{
        Functions.Get(id,(data)=>{
            setOrderData(data);
            if(!inprint.current){
                setTimeout(() => {
                    window.print();
                    window.close();
                }, 400);
            }
            inprint.current = true;
        });
    },[id])
  return (
    <div className='labadmin_lableprint'>
    {orderdata &&
        <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <p>Invoice No: <b>{id}</b></p>
                <p>Pan No: <b>{orderdata.workingpan}</b></p>
            </div>
            {/* Deliberately NO contact details anywhere on this sticker - not the clinic's
                address, not the doctor's email or phone, and not the lab's. The label leaves
                the building attached to a case, so anything printed on it is effectively
                public. Practice and patient name are the minimum needed to identify the case. */}
            <div style={{border:"1px solid #000",padding:"2pt",marginTop:"2pt"}}>
                <p>Practice: <b>{orderdata.clinicname + " / " + orderdata.doctorname}</b></p>
                <p style={{fontSize:"10pt"}}>Patient: <b style={{fontSize:"10pt"}}>{orderdata.patient}</b></p>
            </div>
            <div style={{border:"1px solid #000",borderTop:"none",padding:"2pt"}}>
                <CaseDetails lineItems={orderdata.lineItems}/>
            </div>
            {/* The QR sits BESIDE the chart, not on its own row. The chart is 216pt wide inside
                ~272pt of usable width, so that column was empty anyway - while a QR on its own
                row cost ~40pt of height for a 8pt line of text next to it. Measured saving:
                ~29pt. */}
            <div style={{border:"1px solid #000",borderTop:"none",padding:"2pt"}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                    <div style={{flex:"0 0 auto"}}>
                        <ToothChart lineItems={orderdata.lineItems}/>
                    </div>
                    {/* SVG, not Canvas. QRCodeCanvas rasterises to a bitmap of exactly `size`
                        pixels; printing it at 203 dpi upscales that bitmap ~2x with
                        interpolation, and a 1-bit thermal head dithers the resulting grey edges
                        into mush - that is the blur. SVG is vector, so the print pipeline
                        renders it at the printer's native resolution with hard edges.
                        shapeRendering=crispEdges additionally stops module edges being
                        anti-aliased.
                        includeMargin adds the 4-module quiet zone the QR spec requires -
                        without it the code sits flush against its neighbour and scanners
                        struggle regardless of sharpness. The quiet zone costs modules, so the
                        box is 54 to keep each module ~4 printer dots wide. */}
                    <div style={{flex:"0 0 auto"}}>
                        <QRCodeSVG
                            id="qrCode"
                            value={String(id)}
                            bgColor={"#ffffff"}
                            fgColor={"#000000"}
                            level={"H"}
                            includeMargin={true}
                            size={54}
                            shapeRendering="crispEdges"
                        />
                    </div>
                </div>
            </div>
            {/* The bordered FROM block went with the lab's address, email and phone; the name
                text is now the logo, which already reads "N-VISION Digital Dental Laboratory"
                - keeping both would print the name twice.
                brightness(0) forces the artwork to solid black while preserving its
                transparency. The source PNG is the brand purple, and a 203 dpi thermal head
                is 1-bit, so purple would be dithered into a grey stipple rather than printed
                as a colour. Same reason the QR is drawn as SVG. */}
            <img
                src={Logo}
                alt='N-Vision Digital Dental Laboratory'
                style={{width:"100pt", display:"block", marginTop:"3pt", filter:"brightness(0)"}}
            />
        </>
    }
    </div>
  )
}

export default Index
